<template>
  <portal to="portal-curtain" :disabled="!isPortal">
    <app-curtain-header
      :title="titleCurtain"
      class="main-curtain-header"
    ></app-curtain-header>
    <form
      class="employee-curtain main-curtain-body"
      @submit.prevent="handlerSubmit"
    >
      <employee-form
        ref="employee"
        :employeeData="employee"
        :typeContractor="typeContractor"
      ></employee-form>

      <div
        class="employee-curtain__input-group"
        v-if="!(employee && employee.isSigner)"
      >
        <app-checkbox-control
          v-model="isSigner"
          label="Подписант"
          isTooltipLeft
          tooltip="Подписантом может быть назначен только один сотрудник организации.
            Если сейчас подписантом уже назначен другой сотрудник и вы назначите этого
            сотрудника подписантом, то старый сотрудник автоматически перестанет быть подписантом."
          :id="'signer'"
          :isDisabled="isLoading || employeesLength === 0"
        />
      </div>

      <app-button-control
        :loading="isLoading"
        isWhiteLoader
        nativeType="submit"
        type="secondary"
        is-block
        >{{ textBtnCurtain }}</app-button-control
      >
    </form>
  </portal>
</template>

<script>
import { contractorsMapper } from '@/store/contractors';

export default {
  name: 'EmployeeCurtain',
  components: {
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppCurtainHeader: () => import('@/components/common/AppCurtainHeader'),
    AppCheckboxControl: () => import('@/components/ui/AppCheckboxControl'),
    EmployeeForm: () => import('@/pages/contractors/components/EmployeeForm'),
  },
  props: {
    uuid: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    isPortal: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
    },
    employee: {
      type: Object,
    },
    employeesLength: {
      type: Number,
      default: 0,
    },
    typeContractor: {
      type: String,
      default: '',
    },
  },
  data: (vm) => ({
    isLoading: false,
    isSigner: !vm.employeesLength,
  }),
  computed: {
    /**
     * Заголовок шторки
     * @returns {string}
     */
    titleCurtain() {
      return this.isEdit
        ? 'Редактирование сотрудника'
        : 'Добавление сотрудника';
    },
    /**
     * Текст кнопки в шторке
     * @returns {string}
     */
    textBtnCurtain() {
      return this.isEdit ? 'Изменить сотрудника' : 'Добавить сотрудника';
    },
  },
  methods: {
    ...contractorsMapper.mapActions([
      'createEmployee',
      'editEmployee',
      'makeSigner',
    ]),
    /**
     * Отправка формы
     */
    async handlerSubmit() {
      if (this.$refs.employee.$v.$invalid) {
        this.$refs.employee.$v.$touch();
        return;
      }
      const formData = this.$refs.employee.handlerSubmit();
      if (this.isEdit) {
        await this.edit(formData);
      } else {
        await this.create(formData);
      }
    },
    /**
     * Создание сотрудника
     * @param formData
     */
    async create(formData) {
      this.isLoading = true;
      try {
        const response = await this.createEmployee({ id: this.id, formData });
        if (this.employeesLength > 0 && this.isSigner) {
          await this.makeSigner({ id: this.id, uuid: response.id });
        }
        this.$emit('update');
        this.$modal.hide('main-curtain');
      } catch {
        //
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Редактирование сотрудника
     * @param formData
     */
    async edit(formData) {
      this.isLoading = true;
      try {
        await this.editEmployee({ id: this.id, uuid: this.uuid, formData });
        if (this.isSigner) {
          await this.makeSigner({ id: this.id, uuid: this.uuid });
        }
        this.$emit('update');
        this.$modal.hide('main-curtain');
      } catch {
        //
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.employee-curtain {
  display: block;
  width: 100%;
  max-width: 700px;
  padding-top: 40px;
  margin: auto;
  margin-bottom: 40px;

  @include media-xs() {
    padding-top: 0;
  }

  &__input-group {
    display: flex;
    margin-bottom: 15px;

    @include media-xxs() {
      flex-direction: column;
    }
  }

  &__input,
  &__input-group-item {
    margin-right: 15px;

    @include media-xxs() {
      margin-right: 0;
      margin-bottom: 15px;
    }

    &:last-of-type {
      margin-right: 0;

      @include media-xxs() {
        margin-bottom: 0;
      }
    }
  }
}
</style>
